import CsvTemplate from '../csv-template'

export default class {
  constructor(data) {
    this.firstName = data[CsvTemplate.FIRST_NAME]
    this.middleName = data[CsvTemplate.MIDDLE_NAME]
    this.lastName = data[CsvTemplate.LAST_NAME]
    this.email = data[CsvTemplate.EMAIL]
    this.externalMemberId = data[CsvTemplate.EXTERNAL_MEMBER_ID]

    this.street = data[CsvTemplate.STREET]
    this.city = data[CsvTemplate.CITY]
    this.state = data[CsvTemplate.STATE]
    this.zip = data[CsvTemplate.ZIP]
  }

  get address() {
    return [this.street, this.city, this.state, this.zip].join(', ')
  }

  isValid() {
    return this.firstName 
  }
}
